import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ColumnMode, NgxDatatableModule } from '@swimlane/ngx-datatable';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { getCookie } from '../../../utils/getCookies';
import { EditLicenseComponent } from './modals/edit-license/edit-license.component';
import { MatDialog } from '@angular/material/dialog';
import { ContactFormComponent } from './modals/contact-form/contact-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, ReactiveFormsModule, Validators, FormGroup } from '@angular/forms';
import { ModalPaymentConfirmedComponent } from './modals/modal-payment-confirmed/modal-payment-confirmed.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-compass',
  standalone: true,
  imports: [MatButtonModule, RouterModule, CommonModule, NgxDatatableModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './compass.component.html',
  styleUrl: './compass.component.scss'
})

export class CompassComponent {

  licenses_table: any[] = [];
  licenses_table_assigned: any[] = [];
  user_name: string = getCookie('company_name') || '';
  columnModeSetting = ColumnMode.force;
  scrollBarHorizontal = true;
  selected: any[] = [];
  contactForm: FormGroup;
  loading: boolean = true;
  is_from_validate_email: boolean = false;
  error_validation: boolean = false;
  bought_licenses: boolean = false;
  quantity_bought_licenses: number = 0;
  assigned_licenses: boolean = false;
  assigned_user_email: string = '';
  deleted_licenses: boolean = false;
  deleted_user_email: string = '';
  payment_confirmed: boolean = false;

  constructor(private http: HttpClient, private dialog: MatDialog, private router: Router, private fb: FormBuilder, private route: ActivatedRoute) {
    this.getLicenses();

    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      message: ['', Validators.required],
      terms: [false, Validators.requiredTrue]
    }); 

  // see if we have any params int he url
  this.route.queryParams.subscribe((params: any) => {

    this.payment_confirmed = params['payment_confirmed'];

    /*
    if (params['payment_confirmed'] && (params['payment_confirmed'] === '1' || params['payment_confirmed'] === 1)) {
      
      // eliminar el param de la url
      this.router.navigate([], { queryParams: { payment_confirmed: null }, queryParamsHandling: 'merge' });
      
    }*/
  });

  }


  getLicenses() {
    this.loading = true;
    const headers = {
      headers: {
        Authorization: `Bearer ${getCookie('access_token')}`
      }
    };
    this.http.get(`${environment.url}/api/v1/payments/get_licenses_from_buyer`, headers).subscribe({
      next: (response: any) => {
        this.licenses_table = response.licenses; 
        let is_first_buy = response.is_first_buy;
        
        this.licenses_table_assigned = this.licenses_table.filter((license: any) => license.assigned_to_mail !== null && license.assigned_to_mail !== '');
        this.loading = false;

        let local_quantity_bought_licenses = localStorage.getItem('quantity_bought_licenses');
        if (local_quantity_bought_licenses) {
          this.quantity_bought_licenses = parseInt(local_quantity_bought_licenses);
        }
        else{
          this.quantity_bought_licenses = 0;
        }

        if (!is_first_buy) {
          this.bought_licenses = false;
        }
        is_first_buy = true;
        if (this.payment_confirmed && is_first_buy) {

          (window as any).dataLayer.push({ 
            event: "thank_you",
            plan_name: localStorage.getItem('type_bought_licenses') || '',     // Tipo de plan
            plan_price: parseInt(localStorage.getItem('plan_price_bought_licenses') || '0'),     // Precio final del plan
            users: parseInt(local_quantity_bought_licenses || '0'),     // Cantidad de usuarios que han contratado 
            payment_status: "202",     // Status de pago exitoso
          });

          this.openModalPaymentConfirmed();

          // deactivate the others
          this.assigned_licenses = false;
          this.assigned_user_email = '';
          this.deleted_licenses = false;
          this.deleted_user_email = '';

        }
      }
    });
  }

  goToBuyCompass() {
    this.router.navigate(['/dashboard/company/compass/buy'], { queryParams: { additional_licenses: this.licenses_table.length > 0 ? 1 : 0 } });
  }

  editLicense(row: any) {
    this.dialog.open(EditLicenseComponent, {
      data: {
        row: row,
        type: 'edit',
        title: 'editLicense.title',
        description: 'editLicense.description',
        buttonText: 'editLicense.buttonText'
      }
    }).afterClosed().subscribe((result: any) => {
      if (result) {
        this.getLicenses();
      }
    });
  }

  addLicense() {
    this.dialog.open(EditLicenseComponent, {
      data: {
        type: 'add',
        title: 'editLicense.addTitle',
        description: 'editLicense.addDescription',
        buttonText: 'editLicense.addButtonText'
      }
    }).afterClosed().subscribe((result: any) => {
      if (result) {
        this.getLicenses();

        // deactivate the others
        this.bought_licenses = false;
        this.quantity_bought_licenses = 0;
        this.deleted_licenses = false;
        this.deleted_user_email = '';



        this.assigned_licenses = true;
        this.assigned_user_email = result.email;
      }
    });
  }

  deleteLicense(row: any) {

    this.dialog.open(EditLicenseComponent, {
      data: {
        row: row,
      type: 'delete',
      title: 'editLicense.deleteTitle',
      description: 'editLicense.deleteDescription',
      buttonText: 'editLicense.deleteButtonText'
    }
  }).afterClosed().subscribe((result: any) => {
    if (result) {
      this.getLicenses();

      // deactivate the others
      this.assigned_licenses = false;
      this.assigned_user_email = '';
      this.bought_licenses = false;
      this.quantity_bought_licenses = 0;



      this.deleted_licenses = true;
      this.deleted_user_email = row.assigned_to_mail;
    }
  });
}

  openContactForm() {
    this.dialog.open(ContactFormComponent, {
      data: {},
      width: '60%',
      height: '60%'
    });
  }

  text_message = {
    message: "",
    type: ""
  };

  sendMessage() {

    this.text_message = {
      message: "",
      type: ""
    };
    console.log(this.contactForm.value);

    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      this.text_message = {
        message: "contactForm.errorMessage",
        type: "error"
      }
    } else {

      let values = {
        subject: "Consulta de Conectio",
        message: "Hola, soy " + this.contactForm.value.name + ", mi correo es " + this.contactForm.value.email + " y mi consulta es: " + this.contactForm.value.message,
      }

      this.http.post(environment.url + '/api/v1/payments/send_email_to_support', values).subscribe((res: any) => {
        this.text_message = {
          message: "contactForm.successMessage",
          type: "success"
        }
      }, (error: any) => {
        this.text_message = {
          message: error.error.message,
          type: "error"
        }
      });
    }
  }


  openModalPaymentConfirmed() {
    this.dialog.open(ModalPaymentConfirmedComponent, {
      data: {
        licenses_table: this.licenses_table
      },
      width: '50%',
      height: 'fit-content'
    }).afterClosed().subscribe((result: any) => {
      if (result) {
        this.addLicense()
      }
    });
  }


}
